var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-view",class:_vm.gameViewClasses},[_c('resize-observer',{on:{"notify":_vm.handleGameViewResized}}),_vm._v(" "),_c('scrollable-container',[_c(_vm.gameViewComponentName,_vm._b({tag:"component"},'component',{ gameController: _vm.gameController },false))],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9af28658","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/game/game.html
// module id = null
// module chunks = 